import "../../utils/socket";

import { ConversationEvent, queryKeys, router } from "../../constants/constans";
import React, { lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { SocketClient, socket } from "../../utils/socket";

import Cookies from "js-cookie";
import Home from "../../pages/Home";
import { logout } from "../../utils/helper/common";
import { useQueryClient } from "react-query";

// Pages
// const Home = lazy(() => import("../../pages/Home"));
const CreateSubAccount = lazy(() => import("../../pages/SubAccount"));

const defaultRoutes = [
  {
    // permission: PermissionsKey.SALES_MANAGEMENT,
    path: router.Home.Origin,
    element: <Home />,
  },
];
export default function AppWrapper() {
  const queryClient = useQueryClient();
  useEffect(() => {
    const { socket } = new SocketClient({});

    socket.on(ConversationEvent.LOGIN, () => {
      logout();
    });
    socket.on(ConversationEvent.LOGOUT, () => {
      logout();
    });

    socket.on(ConversationEvent.UPDATE_HOST, () => {
      queryClient.invalidateQueries(queryKeys.listHost);
    });

    // socket.on(ConversationEvent.SYNC_DATA, (data) => {
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 2000);
    // });

    // socket.on(ConversationEvent.UPDATE_TABLE, () => {
    //   queryClient.invalidateQueries(queryKeys.listTableSession);
    // });

    return () => {
      socket.off(ConversationEvent.LOGIN);
      socket.off(ConversationEvent.LOGIN);
      socket.off(ConversationEvent.CREATE_TABLE);
      socket.off(ConversationEvent.UPDATE_HOST);
      socket.off(ConversationEvent.SYNC_DATA);
    };
  }, [Cookies.get("token"), queryClient]);

  return (
    <Routes>
      <Route path={router.Home.Origin} element={<Home />} />
      <Route
        path={router.Profile.AddSubAccount}
        element={<CreateSubAccount />}
      />

      <Route path="*" element={<Home />} />
    </Routes>
  );
}
